import React, { useState, useRef, useEffect, useContext } from "react";
import useForm from "../../hooks/useForm";
import ConfigContext from "../../context/config/ConfigContext";
import AlertContext from "../../context/alert/AlertContext";
import Preloader from "./../layout/Preloader";
import { useHistory } from "react-router-dom";
import NumberFormat from "react-number-format";
import usePageTitle from "../../hooks/usePageTitle";

const UserFeedback = (props) => {
  const alertContext = useContext(AlertContext);
  const configContext = useContext(ConfigContext);

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Feedback",
  });

  const { setAlert, clearAlerts } = alertContext;
  const {
    submitFeedback,
    getConfigValueByCode,
    loadConfig,
    loaded,
    loading,
    getConfigValueByName,
  } = configContext;

  const history = useHistory();

  const [feedback, setfeedback] = useState({
    subject: "",
    name: "",
    email: "",
    phonenumber: "",
    comments: "",
  });

  const [labels, setLabels] = useState({
    subject: "",
    name: "",
    email: "",
    phonenumber: "",
    comments: "",
  });

  useEffect(() => {
    if (!loaded) {
      const getConfigDetails = async () => {
        try {
          const res = await loadConfig();
          console.log("CONFIG RULE MAP", res);
        } catch (err) {
          clearAlerts();
          const msg = getConfigValueByCode(
            "generalConfig",
            "RESPONSE_MSG",
            475
          );
          setAlert(msg, "danger");
        }
      };
      getConfigDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (loaded) {
      let subject = getConfigValueByName(
        "generalConfig",
        "Label",
        "label.subject"
      );
      let name = getConfigValueByName("generalConfig", "Label", "label.name");
      let email = getConfigValueByName("generalConfig", "Label", "label.email");
      let phonenumber = getConfigValueByName(
        "generalConfig",
        "Label",
        "label.phonenumber"
      );
      let comments = getConfigValueByName(
        "generalConfig",
        "Label",
        "label.comments"
      );

      setLabels({
        ...labels,
        subject,
        name,
        email,
        phonenumber,
        comments,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded]);

  const { subject, name, email, phonenumber, comments } = feedback;
  const subjectRef = useRef(null);
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const phonenumberRef = useRef(null);
  const commentsRef = useRef(null);

  const {
    Popup,
    validateField,
    validateAllFields,
    isFormValid,
    setIsFormValid,
    unformattedValues,
    setUnformattedValues,
  } = useForm({
    inputList: {
      subject: subjectRef,
      name: nameRef,
      email: emailRef,
      phonenumber: phonenumberRef,
      comments: commentsRef,
    },
    unformattedValues: {
      phonenumber: "",
    },
    screenName: "feedback_form",
  });

  useEffect(() => {
    const isValid = validateAllFields();
    setIsFormValid(isValid);
    console.log("Form is valid", isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feedback]);

  const onChange = (e) => {
    setfeedback({ ...feedback, [e.target.name]: e.target.value });
  };

  const phoneNoChange = (value, floatValue) => {
    console.log("Formatted Value", value);
    console.log("UnFormatted Value", floatValue);
    setfeedback({ ...feedback, phonenumber: value });
    setUnformattedValues({
      ...unformattedValues,
      phonenumber: floatValue?.toString(),
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await submitFeedback(feedback);
      console.log("--->", res);
      if (res && res.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          res.msgCode
        );
        clearAlerts();
        setAlert(msg, res.status === "ERROR" ? "danger" : "info");
      } else {
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 470);
        setAlert(msg, "info");
      }
      history.push("/");
    } catch (err) {
      console.log("$ERR:", err.message);
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  return (
    <>
      <Popup role="alert" aria-relevant="all" />
      {loading && <Preloader />}
      <div
        className="publicView"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <div className="publicView__pageTitle">
          <div> FeedBack </div>
          {/* <div className="publicView__pageTitle__note">
            <span className="required">*</span>denotes a required field
          </div> */}
        </div>

        <div className="publicView__subPageTitleInfo">
          Please provide your feedback
        </div>

        <div className="publicView__formBody">
          <form>
            <div className="publicView__formGroup">
              <label htmlFor="subject">
                {labels.subject}
                <span className="required" aria-label="Input required">
                  (*Required)
                </span>
                :
              </label>
              <input
                type="text"
                name="subject"
                className="form-control"
                placeholder={labels.subject}
                onChange={onChange}
                value={subject}
                onBlur={validateField}
                ref={subjectRef}
                aria-required="true"
              />
              <div></div>
            </div>
            <div className="publicView__formGroup">
              <label htmlFor="name">{labels.name} :</label>
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder={labels.name}
                onChange={onChange}
                value={name}
                onBlur={validateField}
                ref={nameRef}
                aria-required="true"
              />
              <div></div>
            </div>
            <div className="publicView__formGroup">
              <label htmlFor="email">{labels.email} :</label>
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder={labels.email}
                onChange={onChange}
                value={email}
                onBlur={validateField}
                ref={emailRef}
                aria-required="true"
              />
              <div></div>
            </div>
            <div className="publicView__formGroup">
              <label htmlFor="phonenumber">{labels.phonenumber} :</label>
              <NumberFormat
                name="phonenumber"
                className="form-control"
                onValueChange={(values) => {
                  phoneNoChange(values.value, values.floatValue);
                }}
                placeholder={labels.phonenumber}
                value={phonenumber}
                getInputRef={phonenumberRef}
                onBlur={validateField}
                format="+1 ### ### ####"
              />
              <div></div>
            </div>
            <div className="publicView__formGroup">
              <label htmlFor="comments">
                {labels.comments}
                <span className="required" aria-label="Input required">
                  (*Required)
                </span>{" "}
                :
              </label>
              <textarea
                rows={5}
                name="comments"
                className="form-control"
                placeholder={labels.comments}
                onChange={onChange}
                value={comments}
                onBlur={validateField}
                ref={commentsRef}
                aria-required="true"
              />
              <div></div>
            </div>

            <div className="publicView__formGroup">
              <input
                type="button"
                value="BACK"
                className="btn btn-block btn-primary"
                onClick={() => history.push("/")}
              />
              <input
                type="submit"
                value="SUBMIT"
                onClick={onSubmit}
                className="btn btn-block btn-primary"
                disabled={!isFormValid}
              />
              <div></div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default UserFeedback;
